import type { FunctionComponent } from 'react';

import styles from './IslandNavSeparator.less';

export const IslandNavSeparator: FunctionComponent = () => {
  return <span role="separator" className={styles.separator} />;
};
